module.exports = __webpack_public_path__ + "img/documentation.7d408b8a.svg";